export default __webpack_public_path__ + "static/media/Java.dbae4f1a.png";